import React from 'react';

import Home from 'screens/Home';
import WhatDrivesMe from 'screens/WhatDrivesMe';
import WhatIDo from 'screens/WhatIDo';
import WhoIAm from 'screens/WhoIAm';
import HowIWork from 'screens/HowIWork';
import Contact from 'screens/Contact';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer';

import NavbarContext from 'contexts/navbar';

import './styles.scss';

function App() {
  return (
    <NavbarContext>
      <Home />
      <Navbar />
      <WhatDrivesMe />
      <WhatIDo />
      <HowIWork />
      <WhoIAm />
      <Contact />
      <Footer />
    </NavbarContext>
  );
}

export default App;
